export enum Modules {
  DASHBOARD = 'DASHBOARD',
  REQUISICAO = 'REQUISICAO',
  REQUISICAOAPROVACAO = 'REQUISICAOAPROVACAO',
  ORDEMCOMPRA = 'ORDEMCOMPRA',
  APROVACAO = 'APROVACAO',
  FORCAVENDA = 'FORCAVENDA',
  LICENCA = 'LICENCA',
  MANUTENCAO = 'MANUTENCAO',
  SOLICITACAOCOMPRA = 'SOLICITACAOCOMPRA',
  COTACOES = 'COTACOES',
}


export enum ColorModules {
  DASHBOARD = 'red', 
  REQUISICAO = 'blue', 
  REQUISICAOAPROVACAO = 'green', 
  ORDEMCOMPRA = 'yellow',
  APROVACAO = 'orange', 
  FORCAVENDA = 'purple', 
  LICENCA = 'teal', 
  MANUTENCAO = 'brown', 
  SOLICITACAOCOMPRA = 'pink',
  COTACOES = 'cyan',
 };